import React, { Component } from 'react'
import { logout } from '../../actions/UserActions'
import { connect } from 'react-redux'
import { Menu, Dropdown, Icon } from 'antd'
import LoginModal from '../login/LoginModal'
import _ from 'lodash'
import { Link } from 'react-router-dom'

class LoginLink extends Component {
  state = {
    showLoginModal: false
  }

  onLoginClick() {
    this.props.toggleNav()
    this.loginModalComponent.showLoginModal()
  }

  onLogoutClick() {
    this.props.toggleNav()
    this.props.logout()
  }

  render() {
    const { userState } = this.props
    const user = userState.data
    if (user && user.email) {
      return this.renderLoggedInLink(user)
    } else {
      return this.renderLoginLink()
    }
  }

  renderLoggedInLink(user) {
    const userMenu = this.getUserMenu()
    return (
      <Dropdown overlay={userMenu} trigger={['click']}>
        <span className="link ant-dropdown-link">
          {getUserName(user)} <Icon type="down" />
        </span>
      </Dropdown>
    )
  }

  renderLoginLink() {
    return (
      <div>
        <button
          id="loginLink"
          className="link header-login-link"
          onClick={() => this.onLoginClick()}>
          Sign Up/Login
        </button>
        <LoginModal wrappedComponentRef={c => (this.loginModalComponent = c)} />
      </div>
    )
  }

  getUserMenu() {
    const { userState } = this.props
    return (
      <Menu>
        <Menu.Item key="profile">
          <Link
            to={{
              pathname: '/profile',
              state: { userState: userState }
            }}
            onClick={this.props.toggleNav}>
            Profile
          </Link>
        </Menu.Item>
        <Menu.Item key="garage">
          <Link
            to={{
              pathname: '/my-garage',
              state: { userState: userState }
            }}
            onClick={this.props.toggleNav}>
            My Garage
          </Link>
        </Menu.Item>
        <Menu.Item key="signout">
          <Link to="/" onClick={() => this.onLogoutClick()}>
            Sign Out
          </Link>
        </Menu.Item>
      </Menu>
    )
  }
}

const getUserName = user => {
  if (user) {
    const capitalizedName = _.capitalize(user.firstName)
    return `Hello, ${capitalizedName}`
  }
  return null
}

const mapStateToProps = (state, ownProps) => ({ userState: state.user })
export default connect(
  mapStateToProps,
  {
    logout
  }
)(LoginLink)



// WEBPACK FOOTER //
// ./src/components/layout/LoginLink.js